import React from 'react';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';

const StarRating = ({ rating, size = 'small', showLabel = true, label = '' }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  // Add full stars
  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <StarIcon 
        key={`full-${i}`} 
        sx={{ 
          color: '#FFD700', 
          fontSize: size === 'large' ? '24px' : size === 'medium' ? '20px' : '16px' 
        }} 
      />
    );
  }

  // Add half star if needed
  if (hasHalfStar) {
    stars.push(
      <StarHalfIcon 
        key="half" 
        sx={{ 
          color: '#FFD700', 
          fontSize: size === 'large' ? '24px' : size === 'medium' ? '20px' : '16px' 
        }} 
      />
    );
  }

  // Add empty stars
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <StarBorderIcon 
        key={`empty-${i}`} 
        sx={{ 
          color: '#FFD700', 
          fontSize: size === 'large' ? '24px' : size === 'medium' ? '20px' : '16px' 
        }} 
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {stars}
      {showLabel && (
        <Typography 
          variant="body2" 
          sx={{ 
            ml: 1, 
            fontWeight: 'bold',
            color: 'text.secondary'
          }}
        >
          {label || `${rating}/5`}
        </Typography>
      )}
    </Box>
  );
};

export default StarRating; 